export const getAdStatus = (status: number | string) => {
    switch (status) {
        case 1:
            return '진행중';
        case 2:
            return '종료예정';
        case 3:
            return '종료됨';
        case 4:
            return '심사중';
        case 5:
            return '반려됨';
        case '진행중':
            return 1;
        case '종료예정':
            return 2;
        case '종료됨':
            return 3;
        case '심사중':
            return 4;
        case '반려됨':
            return 5;
        default:
            return status;
    }
};
export const getNotationMethod = (type: number | string) => {
    switch (type) {
        case 1:
            return '진료실명';
        case 2:
            return '의사명';
        case '진료실명':
            return 1;
        case '의사명':
            return 2;
        default:
            return type;
    }
};

export const getDidPointColor = (color: string) => {
    switch (color) {
        case '#0078FF':
            return '블루';
        case '#FF5700':
            return '오렌지';
        case '#DD8EA4':
            return '핑크';
        case '#3D5A5B':
            return '그린';
        case '#E71D36':
            return '레드';
        default:
            return color;
    }
};

export const getDeviceType = (type: number) => {
    switch (type) {
        case 1:
            return '스탠드';
        case 2:
            return '벽걸이';
        case 3:
            return '천장형';
        default:
            return type;
    }
};
export const getDeviceCategory = (cate: number) => {
    switch (cate) {
        case 1:
            return 'LG사이니지';
        case 2:
            return '신형DID';
        case 3:
            return '구형DID';
        default:
            return cate;
    }
};
export const getUseStatus = (status: boolean | string) => {
    switch (status) {
        case true:
            return '사용';
        case false:
            return '미사용';
        case '사용':
            return true;
        case '미사용':
            return false;
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return status;
    }
};

export const getSubscriptionType = (type: number | string) => {
    switch (type) {
        case 1:
            return '무료형';
        case 2:
            return '유료형';
        case '무료형':
            return 1;
        case '유료형':
            return 2;
        default:
            return type;
    }
};
